<template class="events-view-bg" data-app>
    <div style="height: 100%;">
      <v-row style="height: 100%;">
        <!-- Coluna da esquerda -->
        <v-col  class="left-column pa-0">

            <div class="" style="width: 100%;">

                <div class="d-flex align-items-center justify-content-between">

                    <div class="event-title-container">
                      <v-btn fab x-small outlined @click="openInviteDialog" class="ml-2">
                            <v-icon>mdi-account-plus</v-icon>
                        </v-btn>
                        <h1 @click="navigateToEventCreate" class="event-title">
                            {{ eventName }}
                        </h1>

                    </div>

                </div>

                <div class="">
                  <EventDates
                    ref="eventDates"
                    v-show="selected === 'calendar'"
                    :eventId="eventId"
                    :eventDates="eventDates"
                    :eventTimes="eventTimes"
                    :toggleHours.sync="toggleHours"
                    :selectedDate="selectedDate"
                    :eventDuration="eventDuration"
                    :eventDurationValue="eventDurationValue"
                    @date-selected="onDateSelected"
                    @option-selected="onOptionSelected"
                    @date-changed="onDateChanged"
                  />
                  <EventResults
                    v-if="selected === 'results'"
                    :eventId="eventId"
                    :eventDuration="eventDuration"
                    :eventDates="eventDates"
                  />
                </div>
            </div>

            <div class="custom-toggle-container feathered-edges top justify-center">
              <div v-if="selected === 'results'" class="div-close-date-btn">
                  <v-btn color="white"  @click="closeEvent" class="close-date-btn text-none">
                  Fechar data
                </v-btn>
              </div>
              <v-btn-toggle v-model="selected" mandatory class="custom-toggle">
                  <v-btn value="calendar" :class="{'active-btn': selected === 'calendar'}">
                      <v-icon v-if="false" :class="selected === 'calendar' ? 'icon-active-calendar' : 'icon-inactive'">mdi-tune</v-icon> disponibilidade
                  </v-btn>
                  <v-btn value="results" :class="{'active-btn': selected === 'results'}" elevation="0">
                    resultados<v-icon v-if="false" :class="selected === 'results' ? 'icon-active-results' : 'icon-inactive'">mdi-calendar-check-outline</v-icon> 
                  </v-btn>
              </v-btn-toggle>
            </div>

        </v-col>

            
  
        <!-- Coluna do meio -->
        <v-col v-if="this.eventDuration === 'hours' && selected === 'calendar'" cols="6" md="3" class="center-column">

          <div class="icon-switch-container" :style="{ display: selected === 'results' ? 'none' : 'flex' }">
            <v-icon color="black">mdi-clock-outline</v-icon>
            <v-switch
                class="custom-switch"
                color="black"
                @change="updateToggleHours"
            ></v-switch>
          </div>

            <div v-if="!isMobile && toggleHours" class="scrollable-container-times">
              <h3>{{ formatDateExtense(selectedDate) }}</h3>
              <EventTimes
                :key="reloadedEvents"
                v-if="selectedDate && selected === 'calendar'"
                :eventTimes="getEventTimes"
                :selectedDate="selectedDate"
                :selectedOption="selectedOption"
                :autoSelectAll="!toggleHours"
                :minDurationValue="eventDurationValue"
                @time-selected="onTimeSelected"
                ref="eventTimes"
                @reload-calendar="loadEvent"
              />
            </div>

            <v-dialog v-model="eventTimesDialog" v-if="isMobile && toggleHours && selectedDate">
              <v-card class="event-times-card">

                <!-- HEADER FIXO -->
                <v-card-title class="event-times-header background-image">
                  <h5>{{ formatDateExtense(selectedDate) }}</h5>
                  <v-spacer></v-spacer>
                  <v-btn icon color="red" @click="eventTimesDialog = false" class="btn-left">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <!-- BOTÕES (rolam com o resto do conteúdo) -->
                <v-card-title class="headline">
                  <div class="buttons-row">
                    <v-btn
                      v-for="(option, index) in options"
                      :key="index"
                      @click="onOptionSelected(option.value)"
                      :class="[option.class, {'active-button': selectedOption === option.value}]"
                      fab x-small outlined dense
                      class="status-button"
                    />
                    <v-btn
                      @click="onOptionSelected(0)"
                      :class="['status-button', 'x-button', { 'active-x-button': selectedOption === 0 }]"
                      fab
                      x-small
                      dense
                      elevation="0"
                    />
                  </div>
                </v-card-title>

                <!-- CORPO COM SCROLL -->
                <v-card-text class="ma-0 pa-0 dialog-body">
                  <EventTimes
                    :key="reloadedEvents"
                    v-if="selectedDate && selected === 'calendar' && toggleHours"
                    :eventTimes="getEventTimes"
                    :selectedDate="selectedDate"
                    :selectedOption="selectedOption"
                    :autoSelectAll="!toggleHours"
                    @time-selected="onTimeSelected"
                    @option-selected="onOptionSelected"
                    ref="eventTimes"
                    @reload-calendar="loadEvent"
                  />
                </v-card-text>

                <v-card-actions class="headline">
                  <v-spacer></v-spacer>
                </v-card-actions>

              </v-card>
            </v-dialog>




        </v-col>
  
        <!-- Coluna da direita -->
        <v-col cols="12" md="6" class="events-right-column d-none d-md-flex">
            <v-img
              src="@/assets/papelEventos1.png"
              alt="Imagem de Login"
              max-width="100%"
              height="auto"
              contain
              class="img_size"
            />
          </v-col>
      </v-row>

      <!-- Dialog para partilhar link -->
      <v-dialog v-model="inviteDialog" max-width="500px">
          <v-card>
              <v-card-title
                    class="headline background-image modal-partilhar-title">Partilhar Link<v-spacer></v-spacer>
                  <v-btn color="red" icon @click="inviteDialog = false" class="btn-left"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                  <v-text-field
                      v-model="inviteLink"
                      label="Link de Convite"
                      prepend-icon="mdi-link"
                      readonly
                  ></v-text-field>
                  <v-btn icon @click="copyLink"><v-icon>mdi-content-copy</v-icon></v-btn>
                  <v-btn icon @click="shareLink"><v-icon>mdi-share-variant</v-icon></v-btn>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  
              </v-card-actions>
          </v-card>
      </v-dialog>
      <Help :show="openHelpModal" @close="openHelpModal = false" />
    </div>
  </template>
  
  <script>
  import Events from '@/api/Events.js';
  import EventDates from '@/components/events/EventDates.vue';
  import EventTimes from '@/components/events/EventTimes.vue';
  import EventResults from '@/components/events/EventResults.vue';
  import dayjs from 'dayjs'
  import Help from '@/views/Help.vue'
  import 'dayjs/locale/pt'
  
  export default {
    components: {
      EventDates,
      EventTimes,
      EventResults,
      Help
    },
    data() {
      return {
        reloadedEvents: 0,
        eventId: this.$route.params.id,
        eventName: '',
        eventDescription: '',
        openHelpModal: false,
        eventDates: [],
        eventTimes: {},
        eventDurationValue: 0,
        selectedDate: null,
        selectedOption: null,
        selectedOptions: {},
        selected: 'calendar',
        selectedTimes: '',
        inviteDialog: false,
        inviteLink: '',
        eventHash: '',
        eventDuration: '',
        eventTimesDialog: false,
        isMobile: window.innerWidth < 768,
        toggleHours: false,
        eventDatesKey: 0,
        selectedColors: {},
        options: [
          { value: 1, class: 'red-button' },
          { value: 2, class: 'yellow-button' },
          { value: 3, class: 'green-button' },
        ],
        
      };
    },

    watch: {
      
    },

    computed:{
      getEventTimes(){
        //eventTimes[selectedDate] || []
        this.$refs.eventDates.loadEvent()
        this.$refs.eventDates.reloadEventDates()
        console.log('Obtendo horários de eventos para a data:', this.eventTimes);
        return this.eventTimes[this.selectedDate]
      },
    },
    
    methods: {
      formatDateExtense(date) {
        const parsed = dayjs(date)
        return parsed.isValid() ? parsed.locale('pt').format('D [de] MMMM') : ''
      },
        closeEventTimes() {
            this.selectedDate = '';
        },

        formatDate(date) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Intl.DateTimeFormat('pt-BR', options).format(new Date(date));
      },

        checkUserInEvent() {
          try {
              const resp = Events.checkUserInEvent(this.eventId);
              console.log("USER VERIFICADO +++++++++++++++",resp);
          } catch (error) {
              console.error(' Erro:: ', error);
          }
        },

        updateToggleHours() {
          this.selectedDate = null
          this.toggleHours = !this.toggleHours;
        },

        async loadEvent() {
          try {
            const response = await Events.get(this.eventId);

            if (response.data.closed == 1) {
              this.$router.push('/home');
              return;
            }

            if(response.data.preferencial_date_start != null && response.data.preferencial_date_end != null){
              this.$router.push('/event-is-closed/' + this.eventId)
              return
            }

            this.eventName = response.data.title || 'Evento Sem Nome';
            this.eventDescription = response.data.description || 'Sem descrição';
            this.eventHash = response.data.sharable;
            this.eventDuration = response.data.duration_type;
            this.eventDurationValue = response.data.min_duration;

            this.eventDates = [];
            this.eventTimes = {};

            if (Array.isArray(response.data.intervals)) {
              response.data.intervals.forEach(interval => {
                const startDateTime = interval.start_datetime; // "YYYY-MM-DD HH:mm:ss"
                const endDateTime = interval.end_datetime;     // "YYYY-MM-DD HH:mm:ss"

                const startDate = startDateTime.split(' ')[0];
                const endDate = endDateTime.split(' ')[0];
                const startTime = startDateTime.split(' ')[1].slice(0, 5); // "HH:mm"
                const endTime = endDateTime.split(' ')[1].slice(0, 5);     // "HH:mm"

                let currentDate = new Date(startDate);
                const lastDate = new Date(endDate);

                while (currentDate <= lastDate) {
                  const dateStr = currentDate.toISOString().split('T')[0];

                  if (!this.eventDates.includes(dateStr)) {
                    this.eventDates.push(dateStr);
                  }

                  if (!this.eventTimes[dateStr]) {
                    this.eventTimes[dateStr] = [];
                  }

                  // Adiciona horários de início e fim nos dias correspondentes
                  if (dateStr === startDate) {
                    this.eventTimes[dateStr].push({ time: startTime, value: null });
                  }
                  if (dateStr === endDate) {
                    this.eventTimes[dateStr].push({ time: endTime, value: null });
                  }

                  currentDate.setDate(currentDate.getDate() + 1);
                }
              });
            }

            // Processa votos para preencher os valores dos horários
            if (Array.isArray(response.data.votes)) {
              response.data.votes.forEach(vote => {
                const [dateStr, timeStr] = vote.vote_start.split(' ');
                if (!this.eventTimes[dateStr]) {
                  this.eventTimes[dateStr] = [];
                }
                // Procura o horário correspondente e atualiza o value
                const timeObj = this.eventTimes[dateStr].find(t => t.time === timeStr.slice(0, 5));
                if (timeObj) {
                  timeObj.value = vote.vote_value;
                } else {
                  // Se não existe, adiciona
                  this.eventTimes[dateStr].push({
                    time: timeStr.slice(0, 5),
                    value: vote.vote_value
                  });
                }
              });
            }

            console.log('✅ Dados do evento carregados:', this.eventDates, this.eventTimes);

          } catch (error) {
            console.error('❌ Erro ao carregar evento:', error);
            this.eventDates = [];
            this.eventTimes = {};
          }
        },
        
      onDateSelected({ date, option }) {
        if (!this.toggleHours) {
          this.selectedDate = date;
          this.selectedOption = option;
      

          if (this.eventTimes[date]) {
            this.eventTimes[date].forEach(time => {
              time.value = option; 
            });

            // Dispara o evento para salvar no backend
            this.$refs.eventDates.saveTimes().then(() => {

              this.$set(this.eventTimes, date, [...this.eventTimes[date]]);
              this.reloadedEvents++;

              this.$emit('reload-calendar');
            }).catch(error => {
              console.error('❌ Erro ao guardar horários:', error);
            });
            this.$emit('reload-calendar');
          }

          if (!this.eventTimes[date] || !Array.isArray(this.eventTimes[date])) {
            this.$set(this.eventTimes, date, []);
          }

          this.reloadedEvents++;

          if (this.isMobile) {
            this.eventTimesDialog = true;
          }
        }else{
          if (this.isMobile) {
            this.eventTimesDialog = true;
          }
        }
      },
      onOptionSelected(option) {
        this.selectedOption = option;
      },
      onTimeSelected({ time, option }) {
        if (!this.selectedOptions[this.selectedDate]) {
          this.$set(this.selectedOptions, this.selectedDate, {});
        }
        this.$set(this.selectedOptions[this.selectedDate], time, option);
        this.reloadedEvents ++;
        console.log('Hora selecionada:', time);
        console.log('Opção selecionada:', option);
        console.log('Selected options:', this.selectedOptions);

        this.selectedTimes = time;
        

      },

      onDateChanged(date) {
        this.selectedDate = date;
        if (this.$refs.eventTimes && this.$refs.eventTimes.saveTimes) {
        this.$refs.eventTimes.saveTimes().then(() => {
          this.eventTimes[date] = [...this.eventTimes[date]]; // Atualiza os horários
          this.reloadedEvents++; // Incrementa o contador
          console.log('✅ Horários guardados com sucesso: this.eventTimes[date]');
        }).catch(error => {
          console.error('❌ Erro ao guardar horários:', error);
        });
      }
        
      },

      openInviteDialog() {
        this.generateInviteLink(this.eventHash);
        this.inviteDialog = true;
      },


      generateInviteLink(hash) {
        this.inviteLink = `${window.location.origin}/event/hs/${hash}`;
      },

      copyLink() {
        navigator.clipboard.writeText(this.inviteLink).then(() => {
            console.log('Link copiado para a área de transferência');
        }).catch(err => {
            console.error('Erro ao copiar o link:', err);
        });
      },

      shareLink() {
        if (navigator.share) {
            navigator.share({
            title: 'Convite para Evento',
            text: 'Participe no evento ' + this.eventName + '!',
            url: this.inviteLink
            }).then(() => {
            console.log('Link compartilhado com sucesso');
            }).catch(err => {
            console.error('Erro ao compartilhar o link:', err);
            });
        } else {
            console.error('API de compartilhamento não suportada');
        }
      },      
      async saveTimesBeforeNavigation() {
        try {
            await this.$refs.eventDates.saveTimes();
            console.log("✅ ✅ Horários salvos com sucesso: this.$refs.eventDates.saveTimes");
        } catch (error) {
            console.error("❌ Erro ao salvar horários:", error);
        }
      },
      navigateToEventCreate() {
        console.log('A gravar no botão do titulo');
          //await this.saveTimesBeforeNavigation();
          this.$router.push({ name: 'EventsCreate', params: { id: this.eventId } });
      },

      async navigateToResults() {
        console.log('A gravar no botão dos resultados');
          await this.saveTimesBeforeNavigation();
          this.selected = 'results';
      }
    },

    handleClickOutside(event) {
        const eventTimesElement = this.$refs.eventTimes?.$el;
        
        if (eventTimesElement && !eventTimesElement.contains(event.target)) {
        this.selected = '';
        }
    },

    updateIsMobile() {
        this.isMobile = window.innerWidth < 768;
    },

    created() {
      this.loadEvent();
      this.checkUserInEvent();
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        window.addEventListener('resize', this.updateIsMobile);

        console.log("OLHA")
        console.log(this.$root.session.first_login)
        if(this.$root.session.first_login == 0){
          this.openHelpModal = true
          this.$root.session.first_login = 1
        }
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('resize', this.updateIsMobile);
    },


  };
  </script>
  
  <style scoped>

  .fade {
    position: fixed;
    background: linear-gradient(to bottom, rgba(233, 207, 237, 1), rgba(233, 207, 237, 0.2) 100%, transparent 100%);
    width: 100%; height: 20px; z-index: 10;
  }

  ::v-deep(.v-input--selection-controls__input input:checked ~ .v-input--switch__track) {
    background-color: #000 !important;
    border: 1px solid  #000!important;
    opacity: 1 !important;
  }

  ::v-deep(.v-input--selection-controls__input input:not(:checked) ~ .v-input--switch__track) {
    background-color: #D9D9D9 !important;
    border: 1px solid  #000!important;
    opacity: 1 !important;
  }

  ::v-deep(.v-input--switch__thumb) {
    background-color: #e9cfed !important;
    border: 1px solid black !important;
  }

  .events-right-column {
      display: flex;
      justify-content: center; 
      align-items: center;
      height: 100vh;
      /* position: fixed; */
      right: 0;
      top: 0;
      width: 59%;
      padding: 30px;
      margin-right: 30px;
    }

    .img_size {
      width: 600px !important;
      height: 600px !important;
    }

  .left-column {
    position: relative;
    justify-content: flex-start;
    background-color: #e9cfed !important;
    padding: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 600px;
    justify-content: space-between;
    flex-shrink: 1;
  }
  
  .right-column {
    position: sticky;
    right: 0;
    top: 0;
    width: 59%;
    height: 100vh;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: #e9cfed;
    padding: 50px;
  }

  .center-column {
    background-color: #e9cfed;
    margin-top: 9vh;
    padding: 30px;
    display: flex;
    flex-direction: column;
    height: 80vh; /* Alterado para 100vh para garantir que ocupa toda a altura da viewport */
    max-height: 80vh;
    min-height: 80vh;
    gap: 20px;
  }

  .event-title-container {
    display: flex;
    align-items: left;
    flex-grow: 1;
  }

  .event-title {
    font-size: 1.5em;
    margin-bottom: 20px;
    margin-left: 15px;
    color: black;
    text-decoration: underline;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 400px;
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }

  /* btn toggle */
  /* Container Principal */
  .custom-toggle-container {
    position: sticky;
    bottom: 0px; 
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #E9CFED;
    margin-top: 3rem;
    padding-bottom: 1rem;
    /* 
      MC-318 - Alice Serina - 05/02/2026
      moved the close-data-btn element inside .custom-toggle-container
      to make it easier to style and match design

    */
    .div-close-date-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 60px;
      /* 
        MC-318 - Alice Serina - 05/02/2026
        288px is the minimum screen supported witdth (320px with 16px padding on each side).
        max-width is set to avoid becoming as wide as the screen
      */
      min-width: 288px;
      max-width: 360px;
      background-color:  #E9CFED;

      button {
        margin: 0 auto 16px;
        width: 100%;
        border-radius: 25px;
      }
    }
  }

/* Estilo da Toggle */
/* !!! between event availability and results */
.custom-toggle {
    display: flex;
    border-radius: 30px;
    overflow: hidden;
    align-items: center;
    width: 100%;
    height: 36px;
    /* 
      MC-318 - Alice Serina - 05/02/2026
      288px is the minimum screen supported witdth (320px with 16px padding on each side).
      max-width is set to avoid becoming as wide as the screen
    */
    min-width: 288px;
    max-width: 360px;
    border: 2px solid #000000;
    flex-grow: 1;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
    background: none !important;
}

/* Botão Normal */
.custom-toggle .v-btn {
  flex: 1;
  min-width: 140px;
  max-width: 70%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  color: rgb(0, 0, 0);
  background-color: #e9cfed ;
  border-radius: 0px;
  font-size: 16px;
  font-style: normal;
  text-decoration: none;
  text-transform: none;
  transition: background-color 0.3s, color 0.3s;
  font-size: 0.7rem;
}

.custom-toggle .v-btn:before {
    box-shadow: none !important;
    background: transparent !important;
}

::v-deep .v-input--selection-controls__input:hover .v-input--selection-controls__ripple::before {
  background: transparent !important;
  box-shadow: none !important;
}

/* Botão Ativo */
.custom-toggle .v-btn.active-btn {
  background-color: black;
  color: #e9cfed !important;
}

/* Ícones */
.custom-toggle .v-icon {
  font-size: 25px;
  padding: auto;

}

.icon-active-calendar {
  color: #e9cfed !important; /* Cor específica para o ícone ativo do calendário */
}

.icon-active-results {
  color: #e9cfed !important; /* Cor específica para o ícone ativo dos resultados */
}

.icon-inactive {
  color: rgb(0, 0, 0); /* Cor para ícones inativos */
}

.headline {
    position: sticky;
    top: 0;
    z-index: 10;
    justify-content: center;
    align-items: center !important;
    background-color: #fff !important;
    color: black;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  position: sticky;
  top: 0;
  background-color: transparent;
  z-index: 10;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 17px;
}

.buttons-row {
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  gap: 8px;
  margin-top: 5px;
  
}


.add-btn-email {
    
    color: #e9cfed !important;
}

.check-icon {
    color: #cbd8c7 !important;
}

.close-icon {
    color: #fa9a9a !important;
}

.fixed-container {
  position: fixed;
  top: 120px;
  left: 50px;
  bottom: 0px;
  max-height: 72%;
  height: 100dvh; /* Altura total da viewport */
  overflow: hidden; /* Oculta a barra de rolagem */
  display: flex;
  flex-direction: column; 
  justify-content: flex-start;
  align-items: flex-start; 
  width: 100%;

}

.scrollable-content {
  margin-top: 60px; /* Altura do cabeçalho fixo */
  overflow-y: scroll; /* Permite rolagem vertical */
  scrollbar-width: none; /* Oculta a barra de rolagem no Firefox */
}

.scrollable-content::-webkit-scrollbar {
  display: none; /* Oculta a barra de rolagem no Chrome, Safari e Opera */
}

.scrollable-container {
  max-height: 100dvh;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  /* padding-left: 5px; */
}

.scrollable-container-results {
  max-height: calc(100dvh - 170px);
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 200px;
  padding-left: 5px;
}

.scrollable-container-results::-webkit-scrollbar {
  display: none; /* Oculta barra no Chrome, Safari e Opera */
}

.scrollable-container-times {
  max-height: calc(100dvh - 120px);
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 50px;
}

.scrollable-container::-webkit-scrollbar {
  display: none;
}

.scrollable-container::-webkit-scrollbar {
  display: none;
}

.scrollable-container-times::-web
kit-scrollbar {
  display: none;
}

.floating-save-btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.red-button {
    background-color: #fa9a9a;
    color: #fa9a9a
  }

  .yellow-button {
    background-color: #f5e720;
    color: #f5e720;
  }

  .green-button {
    background-color: #cbd8c7;
    color: #cbd8c7;
  }

  .x-button {
  background-color: #e9cfed;
  }

  .active-x-button {
      border: 2px solid black !important; /* Adiciona um contorno preto */
  }


  .active-button {
      background-color: none;
      color:black;
      border: 2px solid black !important; /* Adiciona um contorno preto */
      
  }

  .dialog-body{
    background-color: #fff;
    
  }

  .modal-partilhar-title {
    font-family: 'Urbane Rounded', sans-serif !important;
    font-size: 1.25rem !important;
  }

@media (max-width: 768px) {
    .right-column {
      display: none !important;
    }

    .left-column {
      margin-left: 0;
    }

    .center-column {
      background-color: #e9cfed;
      margin-top: 45px;
      padding: 50px;
      display: flex;
      flex-direction: column;
      height: 80vh; /* Alterado para 100vh para garantir que ocupa toda a altura da viewport */
      max-height: 80vh;
      min-height: 80vh;
      justify-content: space-between; /* Adicionado para garantir que o conteúdo é distribuído entre o topo e o fundo */
      align-items: flex-end;
    }

    .scrollable-container {
        max-height: 100dvh;
        overflow-y: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;
        width: 100%;
        height: 100%;
        align-items: center !important;
        /* padding-left: 1px !important; */
        
    }

    .scrollable-container::-webkit-scrollbar {
        display: none;
    }

  .btn-left {
    margin-left: 20px;
    margin-right: 0;
  }

  .event-title{
    max-width: 230px;
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    margin-bottom: 0;
  }

  .fixed-container {
    top:80px;
    left: 0;
  }

  .custom-toggle{
    width: 100%;
    height: 40px;
  }

  .custom-toggle .v-btn{
    font-size: 12px;
    font-weight: bold;
    min-width: 120px;
    max-width: 100%;
  }
}

.icon-switch-container {
  display: flex;
  align-items: center; /* 🔥 Mantém os itens alinhados verticalmente */
  gap: 4px; /* 🔥 Reduz o espaço entre o ícone e o switch */
  margin-top: 20px;
}

@media (max-width: 979px) {
    .right-column {
      display: none !important;
    }

    .icon-switch-container {
      margin-top: -25px !important;
    }

    .custom-toggle-container {
      /* max-width: 400px !important; */
      background-color: #e9cfed;
      padding: 0.5rem 1.5rem 1rem 1.5rem;
    }

    .event-title-container {
      margin-left: 40px;
      align-items: center;
    }

}
.event-times-card {
  max-height: 90vh;      /* ou o valor que quiseres */
  display: flex;
  flex-direction: column;
}

/* título fixo no topo do card */
.event-times-header {
  position: sticky;
  top: 0;
  z-index: 10;
}

.dialog-body {
  flex: 1;
  overflow-y: auto;
}

</style>